import { rankingData } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-bar-chart-line mr-1"></i>实时榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            吃瓜排行榜
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            基于实时热度与讨论量生成，每两小时自动刷新
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 border border-background-200/60 rounded-xl overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 md:py-5 transition-colors hover:bg-background-200/50 cursor-pointer ${
                idx < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="flex items-center justify-center shrink-0">
                <span
                  className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-500 text-white'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-900 leading-snug truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex items-center gap-2 md:gap-3 shrink-0">
                <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap hidden sm:inline-block">
                  {item.tag}
                </span>
                <span className="text-xs md:text-sm font-medium text-primary-600 whitespace-nowrap">{item.heat}</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  {item.change === 'up' && <i className="ri-arrow-up-fill text-green-500 text-xs"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-fill text-red-400 text-xs"></i>}
                  {item.change === 'new' && <i className="ri-sparkling-2-fill text-accent-500 text-xs"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}